import { render, staticRenderFns } from "./SitchInput.vue?vue&type=template&id=098a4956&scoped=true&"
import script from "./SitchInput.vue?vue&type=script&lang=ts&"
export * from "./SitchInput.vue?vue&type=script&lang=ts&"
import style0 from "./SitchInput.vue?vue&type=style&index=0&id=098a4956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098a4956",
  null
  
)

export default component.exports